export default __webpack_public_path__ + "static/max_logo-042b936f926a04b562ac9f22b8e40d9d.png";